// Generated via oats. Do NOT modify manually.

import * as t from 'io-ts';
import {excess} from '@fl/cmsch-fe-library';

// @ts-ignore: Workaround for "is declared but its value is never read."
import { ValidateCreateBreederBindingAdmin, ValidateCreateBreederBindingAdminSchema } from 'api/gen/ValidateCreateBreederBindingAdmin';
// @ts-ignore: Workaround for "is declared but its value is never read."
import { ValidateUpdateBreederBindingAdmin, ValidateUpdateBreederBindingAdminSchema } from 'api/gen/ValidateUpdateBreederBindingAdmin';

export const ValidateBreederBindingAdminSchema = t.union([ValidateCreateBreederBindingAdminSchema, ValidateUpdateBreederBindingAdminSchema]);

export type ValidateBreederBindingAdmin = t.TypeOf<typeof ValidateBreederBindingAdminSchema>;
